import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';
import { adminKeys } from './keys';
import type { AdminInternalCustomerContextDocumentResponse } from './types';

export const useAdminInternalCustomerContextDocument = (companyId: number) =>
  useQuery<AdminInternalCustomerContextDocumentResponse>({
    queryKey: [adminKeys.INTERNAL_CUSTOMER_CONTEXT_DOCUMENT, companyId],
    staleTime: 0,
    enabled: Number.isInteger(companyId) && companyId > 0,
    queryFn: async () => {
      const response = await fetcher(`admin/companies/${companyId}/context`, {
        method: 'GET',
      });
      if (!response.ok) throw new Error('Failed to load customer context');
      return response.json();
    },
  });
